import { vipInfoApi } from '../../api/vip'

export default {
  state: {
    vipInfo: {
      userviplvl: 0,
      totalrecharge: '',
      totalbetting: '',
    },
    vipDataList: []
  },
  getters: {},
  mutations: {
    setVipInfo(state, data) {
      state.vipInfo = data
    },
    setVipDataList(state, data) {
      state.vipDataList = data
    }
  },
  actions: {
    async getVipInfo(context, params) {
      await vipInfoApi(params).then(res => {
        context.commit('setVipInfo', res.uservip)
        context.commit('setVipDataList', res.data)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/vip.js